import { useMemo, useEffect } from 'react';
import { Grid } from '@creditas-ui/react';
import { useGlobalState } from '@creditas/global-store';
import { SectionTitle } from '@/components/SectionTitle';
import { useGetAccountInformation } from '@/hooks/queries/useGetAccountInformation';
import { useHasPayrollProduct } from '@/hooks/queries/useHasPayrollProduct';
import { useWindowResize } from '@/hooks/helpers/useWindowResize';
import { useAtWorkAvailableProducts } from '@/hooks/queries/useAtWorkAvailableProducts';
import { AvailableProductsResponse } from '@/services/atWorkAvailableProducts';
import i18n from '@/i18n';
import * as Cards from './Cards';

const computeHasStore = (data?: AvailableProductsResponse) => {
  return data?.availableProducts?.includes('STORE');
};

const AtWorkSection = (): JSX.Element => {
  const state = useGlobalState();
  const { isMobile } = useWindowResize();
  const { isSuccess: accountIsSuccess, isLoading: isLoadingAccount } = useGetAccountInformation();
  const {
    isSuccess: payrollIsSuccess,
    data: payrollData,
    isLoading: isLoadingPayroll,
  } = useHasPayrollProduct();
  const { data } = useAtWorkAvailableProducts();

  const showSection = useMemo(() => {
    return accountIsSuccess && payrollIsSuccess && payrollData;
  }, [accountIsSuccess, payrollIsSuccess, payrollData]);

  const hasStore = useMemo(() => computeHasStore(data), [data]);

  const compact = useMemo(() => {
    return !hasStore;
  }, [hasStore]);

  useEffect(() => {
    if (!isLoadingAccount && !isLoadingPayroll) {
      state?.dashboardLoader?.toggleDiscovery?.();
    }
  }, [isLoadingAccount, isLoadingPayroll]);

  return showSection ? (
    <>
      <SectionTitle>{i18n.t('benefitsSection:title')}</SectionTitle>

      <Grid
        marginTop={{ _: '24px', '5xl': '20px' }}
        marginBottom={{ _: '81px', '5xl': '64px' }}
        gridGap={20}
        gridTemplateColumns={{ _: compact && !isMobile ? '1fr 1fr' : '1fr', '5xl': '1fr 1fr' }}
        data-testid="discover-section-content"
      >
        <Cards.AtWorkCard compact={compact} />
      </Grid>
    </>
  ) : (
    <div />
  );
};

export { AtWorkSection };
